import { Networker } from './networker';
export class EmailService {
    static sendEmail(data)  {
        return Networker.post('/nodejs/send-mail', data);
    }
}